import { BrandWordmark } from './brand-wordmark'
import { CardGame } from './card-game'
import styles from './maintenance-screen.module.css'

type Props = {
  onRetry?: () => void
}

export function MaintenanceScreen({ onRetry = () => window.location.reload() }: Props) {
  return (
    <div className={styles.screen}>
      <header className={styles.top}>
        <BrandWordmark height={28} />
        <span className={styles.status}>
          <i aria-hidden="true" />
          Технические работы
        </span>
      </header>
      <main className={styles.body}>
        <span className={styles.eyebrow}>Скоро вернёмся</span>
        <h1 className={styles.title}>Пока мы чиним сайт, можете выбрать себе карту</h1>
        <CardGame count={5} maxWidth={104} />
      </main>
      <footer className={styles.foot}>
        Проверяем связь каждые 15 секунд и откроем сайт, как только всё заработает.{' '}
        <button type="button" onClick={onRetry}>
          Обновить сейчас
        </button>
      </footer>
    </div>
  )
}
